import React from 'react';
const BOTTOM_IMG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/civilian_bottom.jpeg?opt=w3';
export function CtaSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-231">
        <div className="mb-16" data-id="element-232">
          <a href="/training" className="inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light px-8 py-4 text-base gap-2.5" data-id="element-233">
            Click Here to select a Class
          </a>
        </div>

        <div className="w-full border border-brand-gray-800" data-id="element-234">
          <img src={BOTTOM_IMG} alt="Civilian Training" className="block w-full h-auto object-cover" data-id="element-235" />
        </div>
      </div>
    </section>;
}